<div class="image-container">
    <img class="user-pic" [src]="entityImage" alt=""/>
    <mat-icon (click)="triggerFileSelection()">edit</mat-icon>
</div>
<loren-file-upload
        [allowedFileTypes]="allowedFileTypes"
        [fileSizeLimitInMb]="fileSizeLimitInMb"
        (fileSizeExceeded)="showFileSizeExceededError()"
        (fileTypeMismatch)="showFileTypeNotAllowedError($event)"
        (successfulFileUpload)="handleNewImageUpload($event)"
/>